import { render, staticRenderFns } from "./CreationResult.vue?vue&type=template&id=5181c2c2&scoped=true"
import script from "./CreationResult.ts?vue&type=script&lang=ts&external"
export * from "./CreationResult.ts?vue&type=script&lang=ts&external"
import style0 from "./CreationResult.vue?vue&type=style&index=0&id=5181c2c2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5181c2c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5181c2c2')) {
      api.createRecord('5181c2c2', component.options)
    } else {
      api.reload('5181c2c2', component.options)
    }
    module.hot.accept("./CreationResult.vue?vue&type=template&id=5181c2c2&scoped=true", function () {
      api.rerender('5181c2c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/ProcessesForms/components/CreationResult/CreationResult.vue"
export default component.exports